import { render, staticRenderFns } from "./SellersDocument.vue?vue&type=template&id=34716dd6"
import script from "./SellersDocument.vue?vue&type=script&lang=js"
export * from "./SellersDocument.vue?vue&type=script&lang=js"
import style0 from "./SellersDocument.vue?vue&type=style&index=0&id=34716dd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports